import React from 'react';

/**
 * A plain, colour-coded PLACEHOLDER room shell (floor + optional walls) that the
 * worker reskins into a real environment while keeping the hero exact. The
 * colours match the surface studio's legend so the same worker prompt applies:
 *   - warm TAN  = floor
 *   - light GREY = wall
 * Used by the furniture studio's Room mode so a piece can be posed in a corner /
 * against a wall / in the middle before capture (the placement is preserved).
 */

export const ROOM_FLOOR_COLOR = '#C7BCA6'; // warm tan → reads as FLOOR to the reskin
export const ROOM_WALL_COLOR = '#D8D8D4';  // light grey → reads as WALL

export const PlaceholderRoom: React.FC<{
    floorW: number;
    floorD: number;
    wallH: number;
    walls: { back: boolean; left: boolean; right: boolean };
}> = ({ floorW: W, floorD: D, wallH: H, walls }) => {
    return (
        <group>
            <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]} receiveShadow>
                <planeGeometry args={[W, D]} />
                <meshStandardMaterial color={ROOM_FLOOR_COLOR} roughness={1} metalness={0} />
            </mesh>
            {walls.back && (
                <mesh position={[0, H / 2, -D / 2]} receiveShadow>
                    <planeGeometry args={[W, H]} />
                    <meshStandardMaterial color={ROOM_WALL_COLOR} roughness={1} metalness={0} />
                </mesh>
            )}
            {walls.left && (
                <mesh rotation={[0, Math.PI / 2, 0]} position={[-W / 2, H / 2, 0]} receiveShadow>
                    <planeGeometry args={[D, H]} />
                    <meshStandardMaterial color={ROOM_WALL_COLOR} roughness={1} metalness={0} />
                </mesh>
            )}
            {walls.right && (
                <mesh rotation={[0, -Math.PI / 2, 0]} position={[W / 2, H / 2, 0]} receiveShadow>
                    <planeGeometry args={[D, H]} />
                    <meshStandardMaterial color={ROOM_WALL_COLOR} roughness={1} metalness={0} />
                </mesh>
            )}
        </group>
    );
};
